import { values } from 'lodash';
import { orgMilestone as orgMilestoneSchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { selectCurrentOrganizationId } from './auth.js';

// API Actions

const RETRIEVE_ORG_MILESTONES_REQUEST =
  'changesync/orgMilestones/RETRIEVE_ORG_MILESTONES_REQUEST';
const RETRIEVE_ORG_MILESTONES_SUCCESS =
  'changesync/orgMilestones/RETRIEVE_ORG_MILESTONES_SUCCESS';
const RETRIEVE_ORG_MILESTONES_FAILURE =
  'changesync/orgMilestones/RETRIEVE_ORG_MILESTONES_FAILURE';

// Initial State

const initialState = {
  retrieveOrgMilestones: {
    milestoneIds: [],
    pending: false,
    success: false,
    error: null,
  },
};

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_ORG_MILESTONES_REQUEST:
      return {
        ...state,
        retrieveOrgMilestones: {
          ...state.retrieveOrgMilestones,
          pending: true,
          success: false,
          error: null,
        },
      };
    case RETRIEVE_ORG_MILESTONES_SUCCESS:
      return {
        ...state,
        retrieveOrgMilestones: {
          ...state.retrieveOrgMilestones,
          milestoneIds: action.payload.result,
          pending: false,
          success: true,
        },
      };
    case RETRIEVE_ORG_MILESTONES_FAILURE:
      return {
        ...state,
        retrieveOrgMilestones: {
          ...state.retrieveOrgMilestones,
          pending: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

// Action Creators
export const retrieveOrgMilestones = () => (dispatch, getState) => {
  const organizationId = selectCurrentOrganizationId(getState());

  return dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_ORG_MILESTONES_REQUEST,
        RETRIEVE_ORG_MILESTONES_SUCCESS,
        RETRIEVE_ORG_MILESTONES_FAILURE,
      ],
      endpoint: `organizations/${organizationId}/milestones`,
      method: HTTP_METHODS.GET,
      schema: [orgMilestoneSchema],
      disabledDecamelizeKeys: true,
      disabledCamelizeKeys: true,
    },
  });
};

export const selectOrgMilestones = (state) =>
  values(state.entities.orgMilestones);
export const selectRetrieveOrgMilestonesState = (state) =>
  state.orgMilestones.retrieveOrgMilestones;
